export const animationTime = 550
export const mobileWidth = 768